import { create } from 'zustand';
import { getConfig } from '../../config';
import type { AuthConfig } from '../../types/config';

type ConfigState = {
    appConfig?: any;
    authConfig?: AuthConfig;
    fetchConfig: () => Promise<void>;
};

export const useConfigStore = create<ConfigState>((set) => ({
    appConfig: undefined,
    authConfig: undefined,
    fetchConfig: async () => {
        const config = await getConfig();
        const { auth, ...appConfig } = config;
        set({ authConfig: auth, appConfig });
    }
}));
